import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-canteen',
  templateUrl: './canteen.component.html',
  styleUrls: ['./canteen.component.scss']
})
export class CanteenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
